module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    staticClass: "order"
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('m-timer-tip'), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "产品名称",
      "value": _vm.orderName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "承保公司",
      "value": _vm.orderCompany
    }
  })], 1), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "保险信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "订单号",
      "value": _vm.orderNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "投保人",
      "value": _vm.insuredName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号",
      "value": _vm.insuredIDNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "被保险人",
      "value": _vm.insuredName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "身份证号",
      "value": _vm.insuredIDNumber
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "保障额度",
      "value": _vm.insuranceAmountName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费期间",
      "value": _vm.paymentPeriodName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "保险期间",
      "value": _vm.insurancePeriodName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费方式",
      "value": _vm.paymentMethodName
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "每年保费"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "rgb(252, 158, 137)"
    }
  }, [_vm._v(_vm._s(_vm.paymentByIDNumber) + ".00")]), _vm._v("元\n            ")])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "受益人",
      "value": _vm.beneficiary
    }
  })], 1)], 1)]), _vm._v(" "), (this.$store.state.activity.status && this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1 && _vm.isUseCoupon) ? _c('m-column', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "title": "使用优惠券"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "color": "#ccc"
    },
    slot: "right"
  }, [_c('x-button', {
    staticStyle: {
      "border-radius": "100px"
    },
    attrs: {
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showTickets($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.tickedBtnText))]), _vm._v(" >\n      ")], 1)]) : _vm._e(), _vm._v(" "), _c('m-agree-iterms', {
    staticStyle: {
      "margin": "10px 0"
    },
    model: {
      value: (_vm.agreeTerms),
      callback: function($$v) {
        _vm.agreeTerms = $$v
      },
      expression: "agreeTerms"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("本人已认真阅读理解并同意"), _c('a', {
    attrs: {
      "href": "static/docs/toubaoxuzhi.html",
      "target": "_blank"
    }
  }, [_vm._v("《投保须知》")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "static/docs/baoxiantiaokuan.html",
      "target": "_blank"
    }
  }, [_vm._v("《保险条款》")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "static/docs/gaozhiyushengming.html",
      "target": "_blank"
    }
  }, [_vm._v("《投保人声明》")]), _vm._v("、"), _c('a', {
    attrs: {
      "href": "static/docs/tishishu.html",
      "target": "_blank"
    }
  }, [_vm._v("《人身保险投保提示书》")]), _vm._v("的全部内容。")])])])], 1), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "payNow",
    on: {
      "click": _vm.payNow
    }
  }, [_c('span', [_vm._v("立即支付")])])]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showTicket),
      callback: function($$v) {
        _vm.showTicket = $$v
      },
      expression: "showTicket"
    }
  }, [_c('m-column', {
    staticClass: "form",
    attrs: {
      "title": "使用优惠券"
    }
  }, [_c('div', {
    staticClass: "right",
    slot: "right"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.showTicket = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets",
    slot: "body"
  }, [_c('div', {
    staticClass: "tickets-list"
  }, [_c('ul', _vm._l((this.$store.state.activity.tickets), function(ticket, index) {
    return _c('li', {
      key: index,
      staticClass: "cf",
      class: {
        active: ticket.selected
      },
      on: {
        "click": function($event) {
          _vm.selectTicket(index)
        }
      }
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/juanpic3.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "li-left"
    }, [_c('p', {
      staticClass: "li-left-number"
    }, [_c('span', [_vm._v(_vm._s(_vm.ticketValue(ticket.type, ticket.couponValue)))])]), _vm._v(" "), _c('p', [_vm._v("(" + _vm._s(_vm.ticketType(ticket.type)) + ")")]), _vm._v(" "), _c('span', {
      staticClass: "circle cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/selected_ticket.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "li-right"
    }, [_c('p', {
      staticClass: "li-right-title"
    }, [_vm._v(_vm._s(ticket.configName))]), _vm._v(" "), _c('p', [_vm._v("使用范围：" + _vm._s(ticket.includeProductsName))]), _vm._v(" "), _c('p', [_vm._v("使用期限：" + _vm._s(new Date(ticket.beginDate).getFullYear()) + "." + _vm._s(new Date(ticket.beginDate).getMonth() + 1) + "." + _vm._s(new Date(ticket.beginDate).getDate()) + "~" + _vm._s(new Date(ticket.endDate).getFullYear()) + "." + _vm._s(new Date(ticket.endDate).getMonth() + 1) + "." + _vm._s(new Date(ticket.endDate).getDate()))]), _vm._v(" "), _c('p', [_vm._v("使用说明：" + _vm._s(ticket.mark))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tickets-btn"
  }, [_c('div', {
    staticClass: "tickets-des"
  }, [_c('p', [_vm._v("已选择" + _vm._s(this.$store.getters.selectedTickets.length) + "张券，可优惠" + _vm._s(this.$store.state.activity.amountBySelectedTickets) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "tickets-submit",
    on: {
      "click": _vm.sureTicket
    }
  }, [_c('p', [_vm._v("确认使用")])])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a7ecf9"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 648
// module chunks = 1